import * as type from './types';

export function loginOtpF(data) {
    return {
        type: type.GET_OTP_LOGIN_REQUESTED,
        data: data,
    }
}

export function clearLoginOtpFirstStepError() {
    return {
        type: type.CLEAR_LOGIN_OTP_FIRST_STEP_ERROR,
    }
}